import classNames from 'classnames'
import { useState } from 'react'
import { IconSizes } from 'types/general'

import IconRender from '../IconRender'

interface TagProps {
  label: string
  isOutlined?: boolean
  leftIcon?: string
  rightIcon?: string
  size?: IconSizes
  color?: string
  tooltip?: string
}

const Tag = ({
  label,
  isOutlined,
  leftIcon,
  rightIcon,
  size = IconSizes.SM,
  color = 'white',
  tooltip,
}: TagProps) => {
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div
        className={`inline-flex items-center px-3 py-0.5 rounded-xl text-sm font-medium select-none ${
          isOutlined
            ? 'border border-imovPrimary text-imovPrimary'
            : 'bg-imovPrimary text-white opacity-95'
        }`}
      >
        {leftIcon && (
          <IconRender
            icon={leftIcon}
            size={size}
            color={color}
            className="mr-2"
          />
        )}
        <span>{label}</span>
        {rightIcon && (
          <IconRender
            icon={rightIcon}
            size={size}
            color={color}
            className="ml-2"
          />
        )}
      </div>

      {tooltip && showTooltip && (
        <div
          className={classNames(
            'absolute top-full left-1/2 transform -translate-x-1/2 mt-1 w-max rounded-lg text-xs px-3 py-1 shadow-lg transition-opacity duration-500 z-50',
            'bg-gray-100 border-gray-200 border text-imovSecondary',
            showTooltip ? 'opacity-100' : 'opacity-0 pointer-events-none'
          )}
        >
          {tooltip}
        </div>
      )}
    </div>
  )
}

export default Tag
